import moment from "moment"

export const dictFilter = function (value, list) {
  if(list){
    let item = list.find(i => i.value == value);
    if(item){
      return item.name;
    }else{
      return value;
    }
  }else{
    return "";
  }
};
export const splitK =  function(num,int) {
	if(num || num ===0){
		num = Number(num).toFixed(2);
		let fh = "";
		num = String(num);
		if(num.indexOf('-')>-1){
			fh = '-';
			num = num.slice(1);
		}
		let decimal = String(num).split('.')[1] || '00';//小数部分
	   	let tempArr = [];
	   	let revNumArr = String(num).split('.')[0].split("").reverse();//倒序
	   	for (let i in revNumArr){
	     	tempArr.push(revNumArr[i]);
	     	if((i+1)%3 === 0 && i != revNumArr.length-1){
	      		tempArr.push(',');
	        }
	    }
	    let zs = tempArr.reverse().join('');//整数部分
	    if(!int) return decimal?fh+zs+'.'+decimal:fh+zs;
	    if(int) return fh+zs;
	}
	return "0.00";
}
export const time = function(value,opt){
  return moment(value).format(opt)
}



